import React from 'react';

export default function ArrowRight() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.1464 3.64645C13.3417 3.45118 13.6583 3.45118 13.8536 3.64645L21.8536 11.6464C21.9473 11.7402 22 11.8674 22 12C22 12.1326 21.9473 12.2598 21.8536 12.3536L13.8536 20.3536C13.6583 20.5488 13.3417 20.5488 13.1464 20.3536C12.9512 20.1583 12.9512 19.8417 13.1464 19.6464L20.7929 12L13.1464 4.35355C12.9512 4.15829 12.9512 3.84171 13.1464 3.64645Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2 12C2 11.7239 2.22386 11.5 2.5 11.5L21.5 11.5C21.7761 11.5 22 11.7239 22 12C22 12.2761 21.7761 12.5 21.5 12.5L2.5 12.5C2.22386 12.5 2 12.2761 2 12Z"
        fill="white"
      />
    </svg>
  );
}
